<template>
  <vl-layout>
    <vl-grid v-vl-spacer:bottom.medium>
      <vl-column width="12" width-xs="12">
        <vl-toaster mod-bottom-right fade-out class="vl-toaster--large">
          <vl-alert
            v-for="toast in toasts"
            :key="toast.id"
            mod-fade-out
            :icon="toast.icon"
            :mod-error="toast.isError"
            :mod-success="toast.isSuccess"
            closable
            :title="toast.title"
            :content="toast.content"
            @close="closeToast(toast)"
          />
        </vl-toaster>
        <vl-alert
          v-if="alert"
          :icon="alert.icon"
          :mod-error="alert.isError"
          :mod-success="alert.isSuccess"
          closable
          :title="alert.title"
          :content="alert.content"
          @close="closeAlert"
        />
      </vl-column>
    </vl-grid>
  </vl-layout>
</template>
<script lang="ts" setup>
import { useAlertStore, IAlert } from '@/modules/core/store/alert.store';
import { computed } from 'vue';
const store = useAlertStore();

const alert = computed((): IAlert => {
  return store.alert;
});

const toasts = computed((): IAlert[] => {
  return store.toasts;
});

const closeAlert = () => {
  store.clearAlert();
};

const closeToast = (toast: IAlert) => {
  if (toast) {
    store.clearToast(toast.id);
  }
};
</script>
<style lang="scss" scoped>
.vl-toaster {
  width: 35rem;
}

.vl-toaster--large {
  width: 50rem;
}
</style>
